"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var unescape_1 = __importDefault(require("lodash-es/unescape"));
var Styled = __importStar(require("./ApplicationQnAItem.styled"));
var hooks_1 = require("@/hooks");
var ApplicationQnAItem = function (_a) {
    var content = _a.content, description = _a.description, maxContentLength = _a.maxContentLength, answer = _a.answer;
    var convertedContent = (0, hooks_1.useConvertTextToLink)((0, unescape_1.default)(answer.content));
    return ((0, jsx_runtime_1.jsxs)(Styled.ApplicationQnAItemContainer, { children: [(0, jsx_runtime_1.jsx)(Styled.Title, { children: (0, unescape_1.default)(content) }, void 0), description && (0, jsx_runtime_1.jsx)(Styled.Description, { children: (0, unescape_1.default)(description) }, void 0), answer.content && (0, jsx_runtime_1.jsx)(Styled.Answer, { children: convertedContent }, void 0), maxContentLength && ((0, jsx_runtime_1.jsxs)(Styled.TextLength, { children: ["\uCD1D ", (0, jsx_runtime_1.jsx)("strong", { children: (0, unescape_1.default)(answer.content).length }, void 0), "\uC790/", maxContentLength, "\uC790"] }, void 0))] }, void 0));
};
exports.default = ApplicationQnAItem;
